const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/** Validera order-id från /recension?order=… */
export function parseReviewOrderId(raw: string | null | undefined): string | null {
  const value = String(raw ?? '').trim();
  if (!value || !UUID_RE.test(value)) return null;
  return value.toLowerCase();
}

/** Bygg recensions-URL med valfri orderkoppling (för e-post). */
export function buildReviewUrl(siteUrl: string, rentalRequestId?: string | null): string {
  const base = String(siteUrl ?? '').replace(/\/+$/, '');
  const path = `${base}/recension`;
  const orderId = parseReviewOrderId(rentalRequestId);
  if (!orderId) return path;
  return `${path}?order=${encodeURIComponent(orderId)}`;
}
